export enum ProductTypes {
  fan = 'Fan',
  louver = 'Louver',
  gravity = 'Gravity',
  temperedAirProduct = 'TemperedAirProduct',
  circulator = 'Circulator',
  makeUpAir = 'MakeUpAir',
  preconditioners = 'Preconditioner',
}
